import { all } from "redux-saga/effects";
import { quyDinhSoTinChiSaga } from "./quyDinhSoTinChiSaga";
import { quanLyDangKySaga } from "./quanLyDangKySaga";
import { lichSuNapDuLieuSaga } from "./lichSuNapDuLieuSaga";

export default function* quanLyDangKySagaWrapper() {
    yield all([
        quyDinhSoTinChiSaga(),
        quanLyDangKySaga(),
        lichSuNapDuLieuSaga(),
    ]);
}
